import { render, staticRenderFns } from "./PublicCourseView.vue?vue&type=template&id=285d08f6"
import script from "./PublicCourseView.vue?vue&type=script&lang=js"
export * from "./PublicCourseView.vue?vue&type=script&lang=js"
import style0 from "./PublicCourseView.vue?vue&type=style&index=0&id=285d08f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports